/**
 * Adds a ` (n)` copy suffix before the file extension: `photo.jpg` → `photo (1).jpg`.
 * Suffix `0` keeps the name unchanged.
 */
export const withFileNameSuffix = (name: string, suffix: number): string => {
  if (suffix === 0) {
    return name;
  }

  const extensionStart = name.lastIndexOf('.');

  if (extensionStart <= 0) {
    return `${name} (${suffix})`;
  }

  return `${name.slice(0, extensionStart)} (${suffix})${name.slice(extensionStart)}`;
};
